import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { QRCodeComponent } from 'angularx-qrcode';

export interface UnitInfo {
  id?: number;
  code?: string;
  name?: string;
}

export interface UserRole {
  id?: number;
  code?: string;
  name?: string;
}

export interface CreatedByUser {
  id?: number;
  loginname?: string;
  email?: string;
  first_name?: string;
  last_name?: string;
  hrcdf_designation?: string;
  rankCode?: string;
  rankName?: string;
  unit?: UnitInfo;
  roles?: UserRole[];
}

export interface ReportComment {
  id: number;
  code?: string;
  created_on?: string;
  created_at?: string;
  is_main?: boolean;
  created_by?: CreatedByUser | null;
  comment?: string | null;
  replies?: ReportComment[];
  parent_comment?: number | null;
  status?: number;
  sequence?: number;
  proposal_step?: number;
  directorate?: number;
  comment_files?: any[];
}

@Component({
  selector: 'app-comment-thread',
  standalone: true,
  imports: [CommonModule, QRCodeComponent, CommentThreadComponent],
  templateUrl: './comment-thread.component.html',
})
export class CommentThreadComponent {
  @Input() threads: any[] = [];
  @Input() level = 0;

  qrSize = 44;

  constructor(private sanitizer: DomSanitizer) {}

  safeHtml(html: string | null | undefined): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html || '');
  }

  userDisplayName(u: CreatedByUser | null | undefined): string {
    if (!u) return 'Unknown';
    const name = [u.first_name, u.last_name].filter(Boolean).join(' ').trim();
    return  u?.loginname +" "+  u?.rankName + ' ' + name || u?.loginname || u?.email || `User#${u.id ?? ''}`;
  }

  unitDisplay(u: CreatedByUser | null | undefined): string {
    const unit = u?.unit;
    if (!unit) return '';
    return [unit.code, unit.name].filter(Boolean).join(' - ');
  }

  getQrPayload(data: CreatedByUser | null | undefined): string {
    if (!data) return '';
    return JSON.stringify({
      'Electronically Signed by:': `${data?.rankCode ?? ''} ${data?.first_name ?? ''} ${data?.last_name ?? ''}`.trim(),
      'Rank:': data?.rankName ?? data?.rankCode ?? '',
      'Designation:': data?.hrcdf_designation ?? '',
      'Directorate:': data?.unit?.name ?? '',
      'Email:': data?.email ?? '',
    });
  }

  trackByCommentId(index: number, item: ReportComment): number {
    return item.id;
  }
}